import { themeBoxShadow, themeColor } from '@config/theme';
import { Menu, MenuItem as MuiMenuItem } from '@mui/material';
import { MenuItem } from '../types';

interface UserMenuProps {
	anchorEl: HTMLElement | null;
	open: boolean;
	onClose: () => void;
	menuItems: MenuItem[];
}

export const UserMenu: React.FC<UserMenuProps> = ({ anchorEl, open, onClose, menuItems }) => {
	return (
		<Menu
			sx={{
				'& .MuiPaper-root': {
					borderRadius: '5px',
					background: themeColor.contrastTextWhite,
					boxShadow: themeBoxShadow.primary,
				},
			}}
			anchorEl={anchorEl}
			open={open}
			onClose={onClose}
			MenuListProps={{
				sx: {
					padding: '12px 0',
				},
			}}
		>
			{menuItems.map((item, index) => (
				<MuiMenuItem
					sx={{
						color: '#7B809A',
						font: 'roboto-regular',
						fontSize: '16px',
						lineHeight: 'normal',
						padding: '6px 20px',
						'&:hover': {
							backgroundColor: themeColor.veryLightGray,
						},
						'&:not(:last-child)': {
							marginBottom: '6px',
						},
					}}
					disabled={item.disabled}
					key={index}
					onClick={item.onClick}
				>
					{item.icon}
					<p>{item.text}</p>
				</MuiMenuItem>
			))}
		</Menu>
	);
};
